import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";
import { standardLabelStyles } from "../general.styled";

export const InputContainer = styled.div<{
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  marginBottom?: number;
  width?: number;
  $size?: "small" | "medium";
}>`
  position: relative;
  width: ${(p) => (p.width !== undefined ? `${p.width}px` : "100%")};
  max-width: 250px;
  margin-bottom: ${(p) =>
    p.marginBottom !== undefined ? `${p.marginBottom}px` : "16px"};
  margin-right: ${(p) =>
    p.marginRight !== undefined ? `${p.marginRight}px` : "10px"};
  margin-left: ${(p) =>
    p.marginLeft !== undefined ? `${p.marginLeft}px` : "0px"};
  margin-top: ${(p) =>
    p.marginTop !== undefined ? `${p.marginTop}px` : "0px"};
`;

export const InputWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
`;

export const InputLabel = styled.label<{
  required?: boolean;
  hasValue?: boolean;
  isFocused?: boolean;
  disabled?: boolean;
  $size?: "small" | "medium";
}>`
  ${standardLabelStyles}
  font-size: ${(p) => (p.$size === "small" ? FontSize.Tiny : FontSize.Small)};
  line-height: 1.2;
  z-index: 1; /* se till att label ligger över inputbakgrunden */
`;

export const TextInput = styled.input<{
  fontSize?: FontSize;
  hasError?: boolean;
  hasValue?: boolean;
  disabled?: boolean;
  isFocused?: boolean;
  $size?: "small" | "medium";
}>`
  border: 1px solid transparent;
  border-radius: 6px;
  width: 100%;
  background: ${(p) => (p.disabled ? Color.LightGrey02 : "#f8f9fa")};
  color: ${(p) => (p.disabled ? Color.DarkGrey : Color.InputTextColor)};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 400;
  transition: all 0.2s ease;
  outline: none;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "text")};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};

  padding: ${(p) =>
    p.$size === "small"
      ? p.hasValue
        ? "12px 12px 4px 12px"
        : "16px 12px 8px 12px"
      : p.hasValue
      ? "24px 16px 8px 16px"
      : "16px 16px"};

  font-size: ${(p) =>
    p.fontSize ?? (p.$size === "small" ? FontSize.Small : FontSize.Standard)};

  min-height: ${(p) => (p.$size === "small" ? "40px" : "44px")};
  line-height: ${(p) => (p.$size === "small" ? "20px" : "22px")};

  &:focus {
    background: ${(p) => (p.disabled ? Color.LightGrey02 : Color.White)};
    border-color: ${(p) => (p.disabled ? "transparent" : "#e5e7eb")};
    box-shadow: ${(p) =>
      p.disabled ? "none" : "0 0 0 1px rgba(59, 130, 246, 0.1)"};

    padding: ${(p) =>
      p.$size === "small"
        ? p.hasValue
          ? "12px 12px 4px 12px"
          : "16px 12px 8px 12px"
        : p.hasValue
        ? "24px 16px 8px 16px"
        : "16px 16px"};
  }

  &:hover:not(:disabled) {
    background: #f1f3f4;
  }

  ${(p) =>
    p.disabled &&
    `
    padding-right: 40px;
  `}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }


  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const EyeIcon = styled.div`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  display: flex;
  align-items: center;
  z-index: 2;
`;

export const TextArea = styled.textarea<{
  fontSize?: FontSize;
  hasError?: boolean;
  hasValue?: boolean;
  disabled?: boolean;
  isFocused?: boolean;
  resize?: "none" | "vertical" | "horizontal" | "both";
  minRows?: number;
  width?: number;
}>`
  border: 1px solid transparent;
  border-radius: 6px;
  width: ${(props) => (props.width ? props.width + 'px': "100%")};
  min-height: ${({ minRows }) => (minRows ? minRows * 24 + 36 : 120)}px;
  padding: ${({ hasValue }) =>
    hasValue ? "24px 16px 8px 16px" : "28px 16px 8px 16px"};
  background: ${(props) => (props.disabled ? Color.LightGrey02 : "#f8f9fa")};
  font-size: ${(props) => props.fontSize || FontSize.Standard};
  color: ${(props) => (props.disabled ? Color.DarkGrey : Color.InputTextColor)};
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 400;
  transition: all 0.2s ease;
  outline: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "text")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  line-height: 1.5;
  resize: ${({ resize }) => resize ?? "vertical"};

  &::placeholder {
    color: ${Color.Muted};
  }
`;
